const parseQueryParams = (location) => {
  const searchParams = new URLSearchParams(location.search);

  let deviceFilter = null;
  const deviceFilterString = searchParams.get('deviceFilter');
  if (deviceFilterString) {
    try {
      const parts = deviceFilterString.split(',');
      if (Array.isArray(parts)) {
        deviceFilter = parts;
      }
    } catch (e) {
      // Ignore
    }
  } else if (deviceFilterString === '') {
    deviceFilter = [];
  }

  return {
    mode: searchParams.get('mode') || 'live',
    recenterMap: searchParams.get('recenterMap') !== 'false', // Default true
    startAt: searchParams.get('startAt'),
    endAt: searchParams.get('endAt'),
    deviceFilter,
    selectedDevice: searchParams.get('selectedDevice'),
  };
};

const buildUrl = (currentLocation, changes) => {
  const params = {
    ...parseQueryParams(currentLocation),
    ...changes,
  };

  let url = '/home?';

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null) {
      if (Array.isArray(value)) {
        url += `&${key}=${value.join(',')}`;
      } else {
        url += `&${key}=${value}`;
      }
    }
  });
  return url;
};

export default {
  parseQueryParams,
  buildUrl,
};
